import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { MaintenanceDialogComponent } from './dialogs/maintenance-dialog/maintenance-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private modal: BsModalService,
    private router: Router
  ) { }

  ngOnInit() {
    if(environment.maintenanceMode) {
      this.modal.show(MaintenanceDialogComponent, {
        class: 'modal-lg',
        backdrop: 'static',
        ignoreBackdropClick: true
      });
    }

    // On change router scroll to top
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
  }
}
